<div
  [innerHTML]="
    'CARRIERDB.NEW_CARRIER_FORM.DIALOG_DESCRIPTION_P1'
      | translate : locale.language
  "
></div>
<br />
<div
  [innerHTML]="
    'CARRIERDB.NEW_CARRIER_FORM.DIALOG_DESCRIPTION_P2'
      | translate : locale.language
  "
></div>
<br />
<div
  [innerHTML]="
    'CARRIERDB.NEW_CARRIER_FORM.DIALOG_DESCRIPTION_P3'
      | translate : locale.language
  "
></div>
<br />
<div
  [innerHTML]="
    'CARRIERDB.NEW_CARRIER_FORM.DIALOG_DESCRIPTION_P4'
      | translate : locale.language
  "
></div>
<br />
